import { useEffect, useState } from 'react';

export const loadTradeData = async (userID, kinds) => {
  const kindsParam = kinds ? `&kinds=${kinds.join(',')}` : '';
  const response = await fetch(`/api/trades/data?userID=${encodeURIComponent(userID || 1)}${kindsParam}`);
  const payload = await response.json();
  if (!response.ok) throw new Error(payload.message || 'Unable to load saved data.');
  return payload.response || {};
};

export const saveTradeData = async (userID, kind, data) => {
  const response = await fetch(`/api/trades/data/${kind}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userID: userID || 1, data })
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message || 'Unable to save data.');
  }
};

const MOBILE_QUERY = '(max-width: 800px)';
export const useIsMobile = () => {
  const [mobile, setMobile] = useState(() => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches);
  useEffect(() => {
    const query = window.matchMedia(MOBILE_QUERY);
    const update = () => setMobile(query.matches);
    update();
    if (query.addEventListener) query.addEventListener('change', update);
    else query.addListener(update);
    return () => {
      if (query.removeEventListener) query.removeEventListener('change', update);
      else query.removeListener(update);
    };
  }, []);
  return mobile;
};
